
import { Component, Vue } from 'vue-property-decorator'
import RowItem from '@/components/detail/row_item/index.vue'
import RowWrap from '@/components/detail/row_wrap/index.vue'
import { SecurityService } from '@/services'

export const conclusionMap = {
    unqualified: {
        key: 1, name: '不合规'
    },
    suspected: {
        key: 2, name: '疑似'
    },
    auditFailed: {
        key: 3, name: '审核失败'
    }
}

@Component({
    components: {
        RowItem,
        RowWrap
    },
    name: 'bad-info-detail'
})
export default class extends Vue {
    private detail: any = {}

    private get matchConclusion() {
        const item = Object.values(conclusionMap).find(n => n.key === this.detail.conclusion)
        return item ? item.name : ''
    }

    private created() {
        this.getDetail()
    }

    private async getDetail() {
        const params = { id: Number(this.$route.params.id) }
        const result = await SecurityService.getViolatingInfo(params)
        if (result.status === 200) {
            this.detail = result.data
        }
    }
}
